import { Button } from "../components/Button";
import { Callout } from "../components/Callout";
import { Container } from "../components/Container";
import type { SessionErrorReason } from "../session/resolveSession";
import styles from "./screens.module.css";

/**
 * The failure that is Dealbid's problem rather than the founder's.
 *
 * A refused sign-in sends the founder to {@link SignInScreen}, where the Google control is
 * itself the retry. This screen is only for the case where the app could not find out
 * whether anyone is signed in at all — core never answered, or answered something it could
 * not read. No request detail is shown and nothing is logged.
 */
const MESSAGES: Record<SessionErrorReason, { title: string; body: string }> = {
  network: {
    title: "Dealbid couldn't be reached",
    body:
      "Your connection may have dropped, or Dealbid may be briefly unavailable. Nothing has changed on your account — this page just couldn't ask.",
  },
  unexpected: {
    title: "Dealbid answered unexpectedly",
    body:
      "Dealbid replied in a way this page did not expect, so it stopped rather than guessing. Try again; if it keeps happening, sign in again from the start.",
  },
};

export function SessionErrorScreen({
  reason,
  onRetry,
}: {
  reason: SessionErrorReason;
  onRetry: () => void;
}) {
  const { title, body } = MESSAGES[reason];

  return (
    <Container as="main" id="main" className={styles.main}>
      <div className={styles.panel}>
        <h1 className={styles.title}>Open your seller desk</h1>
        <Callout
          tone="error"
          title={title}
          actions={<Button onClick={onRetry}>Try again</Button>}
        >
          {body}
        </Callout>
      </div>
    </Container>
  );
}
